export default __webpack_public_path__ + "static/0087-5f659c35b66a58003a3a9a1be35a9829.png";